import { helpers } from "@vuelidate/validators"

function validatePhoneNumber(value: string) {
  if (!value) return true
  const phoneNumberPattern =
    /(^\+[0-9]{2}|^\+[0-9]{2}\(0\)|^\(\+[0-9]{2}\)\(0\)|^00[0-9]{2}|^0)([0-9]{9}$|[0-9\-\s]{10}$)/
  return phoneNumberPattern.test(value)
}

function validateEmail(value: string) {
  if (!value) return true
  // https://html.spec.whatwg.org/multipage/input.html#valid-e-mail-address
  const emailPattern = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z]{2,})+$/
  return emailPattern.test(value)
}

function validateMultipleEmails(value: string) {
  if (!value) return true
  const emailList = value.split(";").filter((email) => email.trim() !== "")
  return emailList.every((email) => validateEmail(email.trim()))
}

function required(value: any) {
  return value !== undefined && value !== null && value !== ""
}

function validateCitizenNumber(value: string) {
  if (!value) return true

  // A BSN must be exactly 9 digits and contain only numbers.
  if (!/^[0-9]{9}$/.test(value)) return false

  // "Elfproef" (11-test): 9*d1 + 8*d2 + ... + 2*d8 - 1*d9 must be divisible by 11.
  const digits = value.split("").map(Number)
  const sum = digits.reduce((acc, digit, index) => {
    const weight = index === 8 ? -1 : 9 - index
    return acc + digit * weight
  }, 0)

  return sum % 11 === 0
}

export const phoneNumberValidator = helpers.withMessage(
  "Telefoonnummer is ongeldig",
  validatePhoneNumber
)

export const emailValidator = helpers.withMessage("Email is ongeldig", validateEmail)

export const multipleEmailsValidator = helpers.withMessage(
  "Één of meer emailadressen zijn ongeldig",
  validateMultipleEmails
)

export const requiredValidator = helpers.withMessage("Dit veld is vereist", required)

export const citizenNumberValidator = helpers.withMessage(
  "Burgerservicenummer is ongeldig",
  validateCitizenNumber
)
